import React, {Component} from 'react';
import {Link} from 'react-router';
 import formatNumbers  from 'util/formatNumbers';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import moment from 'moment';
 import HistoryDataModal   from 'shared/HistoryDataModal'
import FaCheck from 'react-icons/lib/fa/check';
import config from  '../../../config';
import {dateFormatter, displayCustomDialog, historyDataFormatter, prepareSelectOptionsList,actionsFormatter, customFormatter, priceFormatter, getFieldByPathFormatter} from 'util/Utils';

import {UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT,ADD_SELECTED_PRODUCTS,
REMOVE_SELECTED_PRODUCTS} from "actions/actionTypes";

import TableArrayToCheckboxFormatter from 'shared/table/TableArrayToCheckboxFormatter.js';
import TableArrayToMultiSelectFormatter from 'shared/table/TableArrayToMultiSelectFormatter';
import CustomTableHeaderCheckbox from 'shared/table/CustomTableHeaderCheckbox';


class AdminPalletProductListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.editProduct = this.editProduct.bind(this);
        this.updateProduct = this.updateProduct.bind(this);
        this.deleteProduct = this.deleteProduct.bind(this);
        this.focusAreasOptionsList = _.map(this.props.focusAreas.data, function (item, key) {
            return {'value': item.Name, 'label': item.Name};
        });
        this.state = {
            historyDataModalVisible:false,
            perPage: config.table.numberPerPage,
            currentRecord:{},
        };
        // this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
        //     label: 'DisplayName',
        //     value: '_id'
        // })
        // this.allSellersOptionsList.unshift({label: 'All', value: 'all'});
    }

    componentWillReceiveProps(nextProps) {

        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })

        }
    }
    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = []

      
         if ( _.get(row,'PalletProductData.PalletProductStatus') == 'Checked' &&  _.includes(_.get(row, 'ShopifyProductID', '',), 'temporary') ){  /*&& (_.isUndefined(_.get(row, 'CustomData.AddVariationsRequestID')) || _.get(row, 'CustomData.MainVariation'))) {*/
            menuItemsMap.push({onClick: 'uncheckProduct', label: 'Un-check'})
        }

        menuItemsMap.push({onClick: 'deleteProduct', label: 'Delete record'})
        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }
    editProduct(row) {
        this.context.router.push(`/admin/product/${encodeURIComponent(row._id)}/edit`)
    }
    uncheckAndDeleteVariations(){
        var self = this;
        return this.props.makeRequest({
             AddVariationsRequestID:_.get(this.state.currentRecord, 'CustomData.AddVariationsRequestID')
        }, {
            "endpoint": "/pallets" + '/' + encodeURIComponent(_.get(this.state.currentRecord, 'PalletID'))+'/uncheck-pallet-product-variations',
            type: "patch",
            'not_display_success_message': true,
        }).then(res => {
            self.props.displayMessage({
                 messageCode: 'Variations are deleted and product is unchecked'
            });
            self.props.search()
            this.setState({currentRecord: {}})
        }).catch(err => {

        });
    }
    deleteProductVariations(){
        var self = this;
        return this.props.makeRequest({
            AddVariationsRequestID:_.get(this.state.currentRecord, 'CustomData.AddVariationsRequestID'),
            ProductIDToDelete:_.get(this.state.currentRecord, '_id')
        }, {
            "endpoint": "/pallets" + '/' + encodeURIComponent(_.get(this.state.currentRecord, 'PalletID'))+'/delete-pallet-product-variations',
            type: "patch",
            'not_display_success_message': true,
        }).then(res => {
            self.props.displayMessage({
                messageCode: 'Product variation deleted'
            });
            self.props.search()
            this.setState({currentRecord: {}})
        }).catch(err => {

        });
    }
    uncheckProduct(row){
        var self  = this
        console.log('uncheckProduct'  );
        if (_.get(row, 'CustomData.AddVariationsRequestID')){ /* reset all related products */
            this.setState({showUncheckAndDeleteProductVariations:true,currentRecord:row})
        } else {
            var methodData = {
                type: 'patch',
                endpoint: '/products/' + encodeURIComponent(row._id),
                messageData: {'#1#': 'Product'},
                messageCode: 'recordUpdated'
            }
            var dataToUpdate = {
                Quantity: _.get(row, 'PalletProductData.Quantity', 1),
                PalletProductData: {
                    ..._.get(row, 'PalletProductData', {}),
                    ResetPalletProductData: true,
                    PalletProductStatus: 'Pending',
                }
            }
            this.props.makeRequest(dataToUpdate, methodData).then(function (response) {
                self.props.search()
            }.bind(this));
        }
    }
    updateProduct(data) {
        console.log('in update product',data );
        var objectData = {};
        // if (!_.isUndefined(data.event)) { /* for checkboxes*/
        //     //console.log('event', event.target.getAttribute('value'));
        //     if (data.cellName == 'Status') {
        //         objectData[data.cellName] = data.event.target.checked ? 'Active' : 'Inactive';
        //     }
        // } else {
            objectData[data.cellName] = data.row[data.cellName];
       // }
        var methodData = {
            success_event: UPDATE_ADMIN_PRODUCT,
            type: 'patch',
            endpoint: '/products/' + encodeURIComponent(data.row._id),
            messageData: {'#1#': 'Product'},
            messageCode: 'recordUpdated'
        }
        this.props.makeRequest(objectData, methodData).then(function (response) {
            // this.context.router.goBack();
        }.bind(this));
    }

    hideModal(){
        this.setState({currentRecord:{}, historyDataModalVisible:false});
    }

    deleteProduct(row) {
        console.log('in delete', this.props );
        if (_.get(row, 'CustomData.AddVariationsRequestID')){ /* reset all related products */
            this.setState({showDeleteProductVariation:true,currentRecord:row})
        } else {
            var methodData = {
                'type': 'delete',
                endpoint: '/products/' + encodeURIComponent(row._id),
                messageData: {'#1#': 'Product'},
                messageCode: 'recordDeleted',
                'success_event': DELETE_ADMIN_PRODUCT,
                'success_event_data': {'productID': row._id},
            };
            this.props.makeRequest({}, methodData);
        }
    }





    addCustomClass() {
        return 'center-align-table-column';
    }



    customLinkFormatter(cell, row) {
        return (
            <Link className=""
                  to={`/admin/product/${encodeURIComponent(row._id)}/edit`}>{`${row.ProductName}`}</Link>
        );
    }

    stringToCheckboxFormatter(cell, row, extra) {
         return (
            <input type="checkbox" onChange={(event) => this.updateProduct({row, cellName: extra, event})}
                   defaultChecked={row[extra] == 'Active' ? true : false}>
            </input>
        );
    }

    // stringToSelectboxFormatter(cell, row, extra) {
    //     return (
    //         <Select
    //             tabIndex="0"
    //             placeholder="Seller"
    //             clearable={false}
    //             options={this.allSellersOptionsList}
    //             onChange={(value)=>{this.onSellerChange(row,value)}}
    //             //  filterOptions={filterOptions}
    //             value={row['SellerID'][0]._id}
    //         />
    //     );
    // }








    render() {
        var self = this;


        return (
            <div className="  databases-table">
                <BootstrapTable data={this.props.adminProducts.data} ref='table'
                                 remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                 } }
                 >

                    <TableHeaderColumn width="120px" dataField='ProductName' dataAlign="center"  columnClassName={'break-word'} dataFormat={ this.customLinkFormatter }
                                       dataSort={true}>Title</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataField='PalletID.PalletNumber' dataAlign="center"
                                       formatExtraData={ {path:['PalletID',  'PalletNumber']}}
                                       dataFormat={ getFieldByPathFormatter }     dataSort={true}>Pallet №</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataField='PalletID.PalletNumber' dataAlign="center"
                                       formatExtraData={ {path:['PalletProductData',  'ProductPalletNumber']}}
                                       dataFormat={ getFieldByPathFormatter }     dataSort={true}>Product Pallet №</TableHeaderColumn>
                    <TableHeaderColumn width="25px" dataField='ProductVariants.0.Quantity' dataAlign="center"
                                       formatExtraData={ {path:['ProductVariants', 0, 'Quantity']}}

                                       dataFormat={ getFieldByPathFormatter }   dataSort={true}  >Qty</TableHeaderColumn>
                    <TableHeaderColumn width="0px" dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                       hiddenOnInsert>Id</TableHeaderColumn>


                     <TableHeaderColumn width="40px"    dataFormat={ priceFormatter.bind(this) }  formatExtraData={ {
                         path: ['PalletProductData','RetailToUnit']
                     }} dataField='RetailToUnit' dataAlign="center" dataSort={true}>Retail/unit</TableHeaderColumn>

                    <TableHeaderColumn width="40px" dataField='COGS' dataAlign="center"
                                       dataSort={true}>COGs</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataField='SKU' dataAlign="center"  columnClassName={'break-word'}
                                       dataSort={true}>SKU</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataField='Checked'     dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                         format: (row) => {
                             var setAsCheckedDate =row.createdAt
                             var foundChangeLog =_.findLast(_.get(row, 'ChangeLog',[]), changeLogItem=>{
                                 return changeLogItem.FieldChanged  =='PalletProductStatus' && changeLogItem.To  =='Checked'
                            })
                              if (foundChangeLog){
                                   setAsCheckedDate = foundChangeLog.Date
                             }
                             return _.get(row, ['PalletProductData','PalletProductStatus'])  == 'Checked' ?<div>
                                <FaCheck className="purple text-center"></FaCheck>

                                        <div> {moment(setAsCheckedDate).format('MM/DD')}</div>
                                        <div> {moment(setAsCheckedDate).format('YYYY')}</div>

                            </div>:''
                        }
                    }} dataAlign="center"
                                       >Checked</TableHeaderColumn>
                    <TableHeaderColumn width="35px" dataSort={true} dataField='CreatedInShopifyAt'     dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'],
                                           format: (row) => {


                                               return row.CreatedInShopifyAt ? <div>
                                                   <FaCheck className="purple text-center"></FaCheck>

                                                   <div> {moment(row.CreatedInShopifyAt).format('MM/DD')}</div>
                                                   <div> {moment(row.CreatedInShopifyAt).format('YYYY')}</div>

                                               </div>:''
                                           }
                                       }} dataAlign="center"
                    >Posted</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataField='ReasonCode'   columnClassName={'break-word'}  dataFormat={ customFormatter }
                                       formatExtraData={{
                                           path: ['PalletProductData','ReasonCode'], format: (value) => {
                                                return _.startCase(value)
                                           }
                                       }}  dataAlign="center"
                                        >Reason Code</TableHeaderColumn>
                    <TableHeaderColumn width="50px" dataField='Notes'  columnClassName={'break-word'} dataAlign="center"
                                       formatExtraData={ {path:['PalletProductData',  'PalletProductUpdatedNotes'], path2:['PalletProductData',  'PalletProductNotes']}}
                                       dataFormat={ getFieldByPathFormatter }
                                       dataSort={true}>Notes</TableHeaderColumn>
                    <TableHeaderColumn width="40" dataField='Received' dataAlign="center"
                                       dataFormat={ dateFormatter }
                                       formatExtraData={ {'path': ['PalletProductData',  'PaymentDate'], 'format': 'MM/DD/YY'} }  >Payment Date</TableHeaderColumn>
                    <TableHeaderColumn width="30px" dataAlign="center"  columnClassName={'actions-column'}
                                       dataFormat={ this.customActionsFormatter.bind(this) }
                >Actions</TableHeaderColumn>
                </BootstrapTable>
                <HistoryDataModal data={this.state.currentRecord} hideModal={this.hideModal.bind(this)} show={this.state.historyDataModalVisible} ></HistoryDataModal>
                {displayCustomDialog.call(this, {
                    cancelButtonTitle:'Cancel',
                    buttonTitle:'Un-check and delete variations',
                    cancelActionHandler:()=>{
                    },
                    confirmActionHandler: (data) => {
                        self.uncheckAndDeleteVariations()
                    },
                    modalTitle:'All variations related to this product will be deleted',
                    dialogID: 'UncheckAndDeleteProductVariations'
                })}
                {displayCustomDialog.call(this, {
                    cancelButtonTitle:'Cancel',
                    buttonTitle:'Delete',
                    cancelActionHandler:()=>{
                    },
                    confirmActionHandler: (data) => {
                        self.deleteProductVariations()
                    },
                    modalTitle:'This product variation will be removed and COGs for related product variations recalculated',
                    dialogID: 'DeleteProductVariation'
                })}
            </div>
        );

    }
}


export default AdminPalletProductListTable;
